import React, { PropTypes } from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Immutable from 'immutable';
import { getIconForFormat } from '@bibliocommons/utils-format';
import { metadataIdFixer } from '@bibliocommons/utils-link';
import BibBrief from '@bibliocommons/shared-bib-brief';
import JacketCover from '@bibliocommons/shared-jacket-cover';
import { Generic } from '@bibliocommons/shared-messages';
import AvailabilityBibBlock from '@bibliocommons/availability-bib-block';

import MessagingContainer from '../../../containers/shared/Messaging/MessagingContainer';
import WorkflowContainer from '../../../containers/WorkflowContainer';
import { ShelfMessage } from '../../shared/Messages';
import FormatInfo from '../../../containers/FormatInfoContainer';
import AddToShelfButtonContainer from '../../../containers/AddToShelfButtonContainer';
import ItemTransactionButtonContainer from '../../../containers/ItemTransactionButtonContainer';

import './ItemWidget.scss';

function ItemWidget({ item, availabilityDetail, availabilityDetailActions, currentUser, isWidget }) {
  const bibTitle = item.getIn(['briefInfo', 'title']);
  const jacketSource = item.getIn(['briefInfo', 'jacket']);
  const itemId = item.get('id');

  return (
    <div className={cn('cp-item-widget', { 'is-widget': isWidget })}>
      <div className="col-md-2 visible-md visible-lg outer-jacket">
        <a href={`/item/show/${metadataIdFixer(item.get('id'))}`} tabIndex="-1" aria-hidden="true" target="_parent">
          <JacketCover src={jacketSource} format={item.getIn(['briefInfo', 'format'])} alt="" responsive />
        </a>
      </div>
      <div className="col-md-10 item-column">
        <div className="item-content">
          <div className="item-info">
            <div className="jacket-cover-wrap hidden-md hidden-lg">
              <a href={`/item/show/${metadataIdFixer(item.get('id'))}`} title={bibTitle} target="_parent">
                <JacketCover src={jacketSource} format={item.getIn(['briefInfo', 'format'])} alt={bibTitle} />
              </a>
            </div>
            <div>
              <BibBrief bib={item.get('briefInfo')} renderAuthorsAsLink renderTitleAsLink titleTag="h3">
                <div className="visible-xs brief-extra-info">
                  <a
                    href={`/item/show/${metadataIdFixer(itemId)}`}
                    target="_parent" lang={item.get('primaryLanguage')}
                    rel="noopener"
                    data-test-id={`item-link-${itemId}`}>
                    <FormatInfo item={item} className="manifestation-item-format-info" />
                  </a>
                  <AvailabilityBibBlock
                    bib={item}
                    availabilityStatus={item.get('availability')}
                    availabilityDetail={availabilityDetail}
                    availabilityDetailActions={availabilityDetailActions} />
                </div>
              </BibBrief>
            </div>
          </div>

          <div className="info">
            <div className="row">
              <div className="col-xs-12 availability-status">
                <WorkflowContainer id={itemId}>
                  {(workflowComponent) => workflowComponent || (
                    <div className="manifestation-item cp-manifestation-list-item row" key={itemId}>
                      <MessagingContainer id={itemId}>
                        {
                          (messageOptions, dispatch) => messageOptions.message.get('type') === 'SHELF'
                            ? <ShelfMessage {...messageOptions} dispatch={dispatch} values={messageOptions.message.get('values', Immutable.Map()).merge({ title: bibTitle, username: currentUser.get('name') })} />
                            : <Generic {...messageOptions} values={messageOptions.message.get('values', Immutable.Map()).merge({ title: bibTitle })} />
                        }
                      </MessagingContainer>
                      <div className={`manifestation-item-format-call-wrap ${item.getIn(['availability', 'status']).toLowerCase()}`}>
                        <div className="manifestation-item-format-info-wrap">
                          <span className={getIconForFormat(item.getIn(['briefInfo', 'format']))} aria-hidden />
                          <a
                            href={`/item/show/${metadataIdFixer(itemId)}`}
                            target="_parent" lang={item.get('primaryLanguage')}
                            rel="noopener"
                            data-test-id={`item-link-${itemId}`}>
                            <FormatInfo item={item} className="manifestation-item-format-info" />
                          </a>
                        </div>
                        <div className="manifestation-item-availability-block-wrap">
                          <AvailabilityBibBlock
                            bib={item}
                            availabilityStatus={item.get('availability')}
                            availabilityDetail={availabilityDetail}
                            availabilityDetailActions={availabilityDetailActions} />
                        </div>
                      </div>
                      <div
                        className="manifestation-item-action-wrap toggled-open">
                        <div className="add-to-shelf-wrap">
                          <AddToShelfButtonContainer metadataId={itemId} />
                        </div>
                        <ItemTransactionButtonContainer id={itemId} messagingId={itemId} />
                      </div>
                    </div>
                  )}
                </WorkflowContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ItemWidget.propTypes = {
  item: ImmutablePropTypes.map,
  availabilityDetail: ImmutablePropTypes.map,
  currentUser: ImmutablePropTypes.map,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func),
  isWidget: PropTypes.bool
};

export default ItemWidget;



// WEBPACK FOOTER //
// ./app/components/widgets/ItemWidget/ItemWidget.jsx